<lucide-icon
  [img]="icon()"
  [size]="size()"
  [color]="color()"
  [strokeWidth]="strokeWidth()"
  [absoluteStrokeWidth]="!!absoluteStrokeWidth()"
  [matTooltip]="tooltipText()"
  class="tooltip-icon"
>
  <ng-content></ng-content>
</lucide-icon>
